import React from 'react';
import { string, PropTypes } from 'prop-types';
import classNames from 'classnames/bind';
import { Button, Image } from '@thd-olt-component-react/core-ui';
import styles from './content-provider.scss';
import { iconUrls } from '../../php-card-matrix';

const cx = classNames.bind(styles);
const { brandLogo } = iconUrls;

export const InformationAndCtaPod = ({ service }) => {
  return (
    <div className={cx('information-pod')}>
      <Image
        className={cx('information-pod__carousel-img')}
        src={service?.service_img}
        alt=""
        aria-hidden="true"
      />
      <div className={cx('information-pod__content-wrapper')}>
        <p className={cx('information-pod__heading')}>{service?.title}</p>

        <div className={cx('information-pod__detail')}>{service?.subText}</div>

        <ul>
          <li>{service?.bulletsPoints.first_bullet_point}</li>
          <li>{service?.bulletsPoints.second_bullet_point}</li>
        </ul>
      </div>
      <div className={cx('logo-button-container')}>
        <Button href={service?.button_cta} tag="a" target="_blank" outline>
          {service?.id === 'Generic' ? 'Explore Our Services' : 'Learn More'}
        </Button>
        <Image alt="" width="110" height="55" src={brandLogo} />
      </div>
    </div>
  );
};

InformationAndCtaPod.propTypes = {
  service: PropTypes.shape({
    id: string,
    title: string,
    subText: string,
    service_img: string,
    button_cta: string,
    bulletsPoints: PropTypes.shape({
      first_bullet_point: string,
      second_bullet_point: string,
    }),
  }).isRequired,
};
